import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm8 7h-5v12c0 .55-.45 1-1 1s-1-.45-1-1v-5h-2v5c0 .55-.45 1-1 1s-1-.45-1-1V9H4c-.55 0-1-.45-1-1s.45-1 1-1h16c.55 0 1 .45 1 1s-.45 1-1 1z" fill="#444" /></svg>;